import React, { useState } from "react";
import SimpleReportsPage from "./SimpleReportsPage";
import ReportTemplatesPage from "./ReportTemplatesPage";

const ReportsMainPage = () => {
  const [activeTab, setActiveTab] = useState('simple');

  const tabs = [
    {
      id: 'simple',
      name: 'Отчет по фильтрам',
      icon: '🔍',
      description: 'Фильтрация и поиск заказов по различным критериям'
    },
    {
      id: 'templates',
      name: 'Конструктор отчетов',
      icon: '🏗️',
      description: 'Создание гибких шаблонов с фильтрами и группировкой'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'simple':
        return <SimpleReportsPage />;
      case 'templates':
        return <ReportTemplatesPage />;
      default:
        return <SimpleReportsPage />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Навигация вкладок */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <span className="text-lg">{tab.icon}</span>
                  <div className="text-left">
                    <div className="font-semibold">{tab.name}</div>
                    <div className="text-xs text-gray-400 hidden md:block">
                      {tab.description}
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Содержимое вкладки */}
      <div>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ReportsMainPage;